import React from "react";
import { Heart } from "lucide-react";
import { IMAGES } from "@/config";

export default function DonatePage() {
  return (
    <div className="donate-page">
      <section 
        className="donate-hero-section"
        style={{ 
          backgroundImage: `url('${IMAGES.donateBackground}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          minHeight: '100vh'
        }}
      >
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(10, 10, 10, 0.6)' }}></div>
        <div className="container" style={{ position: 'relative', padding: '3rem 1rem 4rem' }}>
          <div className="donate-header">
            <Heart size={48} className="donate-icon" />
            <h1 className="section-title" style={{ fontSize: '2.5rem' }}>Support Funchester TV</h1>
            <p className="donate-intro">
              <strong>Why Donate?</strong><br/>
              Funchester TV has been a passion project for over 10 years, run purely for the love of Kentucky basketball and for fans like me. I'm not doing this for profit. Internet, servers, and keeping everything running do cost money, so if you've enjoyed the streams or the Vault and want to show some appreciation, any donation is greatly appreciated. 100% of donations go straight back into the website, though donations are never required — this will always stay free for every UK fan. Thank you! Go Big Blue!
            </p>
          </div>
          
          <div className="donation-icons-grid">
            <a 
              href="https://www.paypal.com/paypalme/funchester" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="donation-icon-link"
              data-testid="donate-paypal"
            >
              <img src={IMAGES.paypalIcon} alt="Support via PayPal - paypal.me/Funchester" className="donation-icon-img" />
            </a>
            
            <a 
              href="https://venmo.com/Todd-Faulconer" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="donation-icon-link"
              data-testid="donate-venmo"
            >
              <img src={IMAGES.venmoIcon} alt="Tip through Venmo - @Todd-Faulconer" className="donation-icon-img" />
            </a>
            
            <a 
              href="https://cash.app/$Funchester" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="donation-icon-link"
              data-testid="donate-cashapp"
            >
              <img src={IMAGES.cashAppIcon} alt="Fuel the Stream - Cash App $Funchester" className="donation-icon-img" />
            </a>
          </div>
          
          <div className="donate-thanks">
            <p>Thanks again for all of you making this a great community for us to watch our Cats play.</p>
            <p className="go-big-blue">Go Big Blue!</p>
          </div>
        </div>
      </section>
    </div>
  );
}
